<template>
  <div id="app3" class="app">
    <!-- <div class="row">
      <div class="col-12">
        <hero-banner v-if="wizardStep === 0" :title="content.heroBanner"></hero-banner>
      </div>
    </div> -->
    <div class="main">
      <div class="container margin-top-30 margin-bottom-70">
        <div class="row">
          <div class="col-12">
            <section-cui v-if="wizardStep === 0"></section-cui>
            <header-wizard v-if="wizardStep > 0 && wizardStep < 7"></header-wizard>
            <wizard-step-1 v-if="wizardStep === 1"></wizard-step-1>
            <wizard-step-2 v-if="wizardStep === 2"></wizard-step-2>
            <wizard-step-3 v-if="wizardStep === 3"></wizard-step-3>
            <wizard-step-4 v-if="wizardStep === 4"></wizard-step-4>
            <wizard-step-5 v-if="wizardStep === 5"></wizard-step-5>
            <wizard-step-6 v-if="wizardStep === 6"></wizard-step-6>
            <section-final v-if="wizardStep === 7"></section-final>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SectionCui from "./components/formSponsorship177/SectionCui";
import HeaderWizard from "./components/formSponsorship177/HeaderWizard";
import SectionFinal from "./components/formSponsorship177/SectionFinal";
import WizardStep1 from "./components/formSponsorship177/WizardStep1";
import WizardStep2 from "./components/formSponsorship177/WizardStep2";
import WizardStep3 from "./components/formSponsorship177/WizardStep3";
import WizardStep4 from "./components/formSponsorship177/WizardStep4";
import WizardStep5 from "./components/formSponsorship177/WizardStep5";
import WizardStep6 from "./components/formSponsorship177/WizardStep6";
import HeroBanner from "./components/global/HeroBanner";

import Content from "./content/pages/FormSponsorship";

export default {
  name: "app",
  data() {
    return {
      content: Content
    };
  },
  computed: {
    ...mapState({
      wizardStep: state => state.wizardStep
    })
  },
  components: {
    HeroBanner,
    SectionCui,
    HeaderWizard,
    WizardStep1,
    WizardStep2,
    WizardStep3,
    WizardStep4,
    WizardStep5,
    WizardStep6,
    SectionFinal
  }
};
</script>

<style lang="scss">
.app {
  height: 100%;
}

.main {
  position: relative;
  z-index: 10;
}

.container-form {
  position: relative;
  max-width: 920px;
}

.margin-top-30 {
  margin-top: 30px !important;
}

.margin-bottom-70 {
  margin-bottom: 70px !important;
}

.margin-top-42 {
  margin-top: 42px !important;
}

.margin-top-15 {
  margin-top: 15px !important;
}

.section-name-form {
  font-weight: 900;
  margin: 4px 0px;
}

.section-description-form {
  font-size: 1.1rem;
  font-weight: 300;
  color: #97a1ab;
}

.align-button-form {
  float: right;
}

@media (max-width: 700px) {
  .align-button-form {
    float: left;
  }
}

.datepicker-input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
}

.datepicker-error {
  display: block;
  border: 1px solid #bd1f23;
  color: #bd1f23 !important;
}
</style>
